/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {AbmsBoardService} from './abms-board.service';
import {AbmsBoardSubspecialtyModule} from './subspecialty/abms-board-subspecialty.module';

@NgModule({
    imports: [AbmsBoardSubspecialtyModule],
    providers: [
        AbmsBoardService
    ]
})
export class AbmsBoardModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/abms/abms-board.module.ts